import Rellax from "rellax";

export default function parallax() {
  const mq = window.matchMedia('(min-width: 1024px)');

  const rellaxBlob = new Rellax('.rellax-blob', {
    speed: 0.5,
  });

  const rellaxPhoto1 = new Rellax('.rellax-photo-1', {
    speed: 0.3,
    center: true,
  });

  const rellaxPhoto2 = new Rellax('.rellax-photo-2', {
    speed: 0.8,
    center: true,
  });

  function handleParallax(mq) {
    if(mq.matches) {
      const rellaxLargeBg = new Rellax('.rellax-bg', {
        speed: -1.0,
        center: true,
      });

      const rellaxLargeDot = new Rellax('.rellax-dot', {
        speed: -0.6,
        center: true,
      });

      rellaxPhoto1.refresh();
      rellaxPhoto2.refresh();

    } else {
      const rellaxSmallBg = new Rellax('.rellax-bg', {
        speed: -0.8,
        center: true,
      });

      const rellaxSmallDot = new Rellax('.rellax-dot', {
        speed: -0.2,
        center: true,
      });

      rellaxPhoto1.destroy();
      rellaxPhoto2.destroy();
    }
  }

  mq.addListener(handleParallax);

  handleParallax(mq);
}

parallax();
